<template>
  <chat-box
    ref="chatbox"
    avatar="/assets/images/chatbot.png"
    @open="open"
    v-show="botConfigurado"
  >
    <div class="ChatBot__header">
      <span style="position: relative;top: -2px;">
        <img
          class="ChatBot__image"
          alt="Robô azul representando o Bot que responde ao chat"
          src="/assets/images/chatbot.png"
        />
      </span>
      <div class="ChatBot__name">
        <div>Mave</div>
        <div class="role">bot</div>
      </div>
      <button
        type="button"
        class="ChatBot__close button btn -small -clear"
        @click="closeChat"
        aria-label="Fechar o suporte via chat"
      >
        <svg
          viewBox="0 0 24 24"
          aria-hidden="true"
          focusable="false"
          style="display: block; fill: rgb(200, 200, 200); height: 13px; width: 13px;"
        >
          <path
            fill-rule="evenodd"
            d="M23.25 24a.744.744 0 0 1-.53-.22L12 13.062 1.28 23.782a.75.75 0 0 1-1.06-1.06L10.94 12 .22 1.28A.75.75 0 1 1 1.28.22L12 10.94 22.72.22a.749.749 0 1 1 1.06 1.06L13.062 12l10.72 10.72a.749.749 0 0 1-.53 1.28"
          ></path>
        </svg>
      </button>
    </div>
    <div class="chat"></div>
  </chat-box>
</template>

<script>
import YveBotUI from "yve-bot/ui";
import ChatBox from "../ChatBox";
import rules from "js-yaml-loader?safe=false!./com-cadastro.yaml";
import { subdomainUrl } from "../../../user/js/utils/url";
import { validateNumeroUnicoProcesso } from "../../../js/utils/string";
import usuarioApi from "../../api/usuario";
import ismobile from "ismobilejs";

export default {
  data() {
    return {
      bot: null,
      botConfigurado: false,
      botIniciou: false,
      botDigitando: false
    };
  },
  mounted() {
    if (!window.navigator.userAgent.match(/Firefox\/([0-9]+)\./)) {
      this.inicializarBot();
    }
  },
  methods: {
    validacoes() {
      // Numero unico do processo
      this.bot.validators.define("numeroUnico", {
        validate: (esperado, resposta) => {
          return !!validateNumeroUnicoProcesso(resposta);
        },
        warning:
          "Por favor, informe o processo na numeração única.<br>Ex: 0000000-00.2015.8.05.0000"
      });

      // Termo valido para monitorar
      this.bot.validators.define("termoValido", {
        validate: (esperado, resposta) => {
          const palavrasProibidas = [
            "remova",
            "remoção",
            "remover",
            "removessem",
            "excluir",
            "exclusão",
            "retirar",
            "meus dados",
            "não autorizei"
          ];
          for (let i = 0; i < palavrasProibidas.length; i++) {
            if (resposta.toLowerCase().includes(palavrasProibidas[i])) {
              return false;
            }
          }

          return true;
        },
        warning:
          "Para remover um nome do Escavador siga os seguinte passos: <a class='link -color' href='" +
          subdomainUrl(
            "ajuda",
            "/remocao-de-informacoes/como-retirar-o-meu-nome-ou-da-minha-empresa-de-uma-publicacao"
          ) +
          "'>Como retirar o meu nome, ou da minha empresa, de uma publicação?</a><br><br>Informe o termo a ser monitorado"
      });

      // Verificar se o e-mail está confirmado
      this.bot.validators.define("verificar-email-confirmado", {
        validate: async (externalAPI, answer) => {
          return this.$store
            .dispatch("getAuthUser")
            .then(result => this.$store.state.usuario.user.confirmed === 1);
        },
        warning: "Você ainda não confirmou seu e-mail"
      });
    },
    eventos() {
      // Bloqueia o input enquanto o bot digita
      this.bot.on("typing", () => {
        this.botDigitando = true;
        this.bot.UI.input.blur();
        this.bot.UI.submit.setAttribute("disabled", "disabled");
        this.bot.UI.input.setAttribute("disabled", "disabled");
      });

      // Desbloqueia quando o bot termina de falar, se não para clicar em opções
      this.bot.on("talk", (message, rule) => {
        this.botDigitando = false;

        if ((rule.options || []).length === 0) {
          this.bot.UI.submit.removeAttribute("disabled");
          this.bot.UI.input.removeAttribute("disabled");
          this.bot.UI.input.focus();
        }
      });

      this.bot.on("error", async (err, sessionId) => {
        await this.bot.talk(
          "Desculpa, mas não estou conseguindo criar o seu monitoramento por aqui"
        );
        await this.bot.talk(
          "Você poderia criar pelo nosso painel de monitoramentos?"
        );
        await this.bot.talk(
          'Basta clicar em <a class="link -color" href="' +
            subdomainUrl("monitoramentos", "/novo") +
            '">Novo monitoramento</a>'
        );
        this.bot.end();
      });

      this.bot.on("end", (output, sessionId) => {
        this.$store.dispatch("registrarAcao", {
          acao: "CONVERSOU_CHATBOT",
          propriedades: {
            conversa: output
          }
        });
      });
    },
    async acoes() {
      // Carrega informações do usuário
      await this.$store.dispatch("getAuthUser").then(() => {
        this.bot.store.data.output = {
          nome: this.$store.state.usuario.user.nome,
          primeiroNome: this.$store.state.usuario.user.primeiro_nome,
          email: this.$store.state.usuario.user.email,
          emailConfirmado: this.$store.state.usuario.user.confirmed === 1,
          estadoId:
            this.$store.state.usuario.user.estado !== null
              ? this.$store.state.usuario.user.estado.id
              : null,
          estadoUf:
            this.$store.state.usuario.user.estado !== null
              ? this.$store.state.usuario.user.estado.uf
              : null,
          locais: "pais",
          criouMonitoramentoNome: false
        };
      });

      this.bot.actions.define(
        "cadastrarMonitoramento",
        async (actionOptions, bot) => {
          const monitoramento = this.bot.store.get("output.monitoramento");
          const locais = this.bot.store.get("output.locais");

          if (monitoramento.tipo === "processo") {
            monitoramento.categoria = "PROCESSO";
          }

          let data = {
            tipo: monitoramento.tipo,
            termo: monitoramento.termo,
            numero_processo: monitoramento.termo,
            categoria: monitoramento.categoria,
            origem_criacao: "CHATBOT"
          };

          // Se o usuário marcou para monitorar só no estado dele
          if (locais === "estado") {
            data["estados_ids"] = [this.bot.store.get("output.estadoId")];
            // Senão monitora em todos os diários
          } else {
            data["monitorar_em_todos_diarios"] = true;
          }

          try {
            await this.$store.dispatch("criarMonitoramento", {
              form: data,
              processo: data.tipo === "processo"
            });
          } catch (err) {
            throw "Erro";
          }
        }
      );

      this.bot.actions.define(
        "reenviarConfirmacaoCadastro",
        async (actionOptions, bot) => {
          usuarioApi.reenviarEmailConfirmacao({ reenviado: true });
        }
      );

      this.bot.actions.define(
        "redirecionarPainel",
        async (actionOptions, bot) => {
          setTimeout(() => {
            window.location.href = subdomainUrl("monitoramentos");
          }, 3000);
        }
      );
    },
    inicializarBot() {
      let options = {
        target: ".chat",
        name: "",
        inputPlaceholder: "Escreva sua mensagem",
        inputPlaceholderSingleChoice: "Escolha uma opção",
        inputPlaceholderMultipleChoice: "Escolha as opções",
        doneMultipleChoiceLabel: "Pronto",
        moreOptionsLabel: "Mais opções",
        andSeparatorText: "e",
        submitLabel: "Enviar"
      };

      // Cria a instancia do BOT
      this.bot = new YveBotUI(rules, options);

      this.validacoes();
      this.eventos();
      this.acoes();

      // Seta que foi configurado o bot
      this.botConfigurado = true;
    },
    open() {
      if (!this.botIniciou) {
        this.bot.start();
        this.botIniciou = true;
      }
      if (ismobile.any) {
        document.documentElement.setAttribute("style", "overflow:hidden;");
      }
    },
    closeChat() {
      this.$refs.chatbox.togglePreChat();
      document.documentElement.setAttribute("style", "overflow:scroll;");
    }
  },
  components: {
    ChatBox
  }
};
</script>

<style>
.ChatBot__header {
  background-color: #1c2c3b;
  height: 70px;
  padding: 15px;
  color: #fff;
  font-size: 15px;
  border-radius: 4px 4px 0 0;
}

.ChatBot__close {
  float: right !important;
}

.ChatBot__close:hover,
.ChatBot__close:active {
  background: none !important;
}

.ChatBot__image {
  border-radius: 50%;
  width: 42px;
  height: 42px;
}

.ChatBot__name {
  display: inline-table;
  vertical-align: bottom;
  margin-left: 5px;
  padding-top: 0;
  font-size: 17px;
}

.ChatBot__name .role {
  font-size: 14px;
  font-weight: 100;
  color: rgba(255, 255, 255, 0.8);
}

.ChatBox form {
  background: #f2f2f2;
  padding: 3px;
  position: absolute;
  bottom: 0;
  width: 100%;
}

.ChatBox form input,
.ChatBox form textarea {
  border: 0;
  padding: 10px;
  width: 83%;
  margin-right: 0.5%;
  font-size: 13px;
}

.ChatBox form textarea {
  resize: none;
  height: auto;
  min-height: 36px;
  vertical-align: middle;
}

.ChatBox form button {
  width: 15%;
  background-color: transparent;
  border: none;
  padding: 10px 5px;
  color: #999;
  font-size: 12px;
  cursor: pointer;
}

.ChatBox form button:hover {
  color: #333;
}

.yvebot-thread-bot {
  position: relative;
  padding: 0 0 0 48px;
}

.yvebot-thread-bot .yvebot-bubble {
  margin-right: 30px;
}

.yvebot-thread-user .yvebot-bubble {
  margin-left: 30px;
}

.yvebot-thread-user .yvebot-bubble {
  background-color: rgba(246, 189, 31, 0.3);
}

.yvebot-thread-bot:before {
  content: "";
  background-size: cover;
  background-image: url(/assets/images/chatbot.png);
  margin-bottom: 1px;
  text-align: center;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
}

.yvebot-conversation {
  overflow-y: scroll;
  height: calc(100vh - 115px);
  list-style-type: none;
  margin: 0;
  padding: 8px;
  padding-bottom: calc(48px + 1rem);
}

@media screen and (min-width: 560px) {
  .yvebot-conversation {
    height: calc(50vh - 40px);
  }
}

.yvebot-thread {
  margin: 3px 3px 10px;
}

.yvebot-sender {
  font-weight: bold;
}

.yvebot-bubble,
.yvebot-typing {
  display: inline-block;
  padding: 5px 10px;
  border-radius: 8px;
}

.yvebot-thread-bot .yvebot-bubble,
.yvebot-thread-bot .yvebot-typing {
  background-color: #eee;
}

.yvebot-thread-user {
  text-align: right;
}

.yvebot-message-bubbleBtn {
  background: none;
  color: #1d82e0;
  border-radius: 8px;
  font: inherit;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  overflow: visible;
  padding: 3px 10px;
  border: 1px solid #1d82e0;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin-right: 5px;
}

.yvebot-message-bubbleBtn:hover {
  background: #8ed3ff;
}

.yvebot-message-bubbles {
  margin-top: 8px;
}

.yvebot-message-bubbleDone {
  outline: none;
  float: right;
  margin-top: 5px;
  background-color: transparent;
  border: 0;
  color: #168eda;
  font-size: 13px;
  cursor: pointer;
}

.yvebot-message-bubbleDone:hover {
  text-decoration: underline;
}

.yvebot-thread-typing {
  display: none;
}

.yvebot-thread-typing.is-typing {
  display: block;
}

.yvebot-typing-dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #999;
  margin-right: 4px;
  animation: wave 1.3s linear infinite;
}

.yvebot-typing-dot:nth-child(2) {
  animation-delay: -1.1s;
}

.yvebot-typing-dot:nth-child(3) {
  animation-delay: -0.9s;
}

#output {
  padding: 16px;
  color: #777;
  position: fixed;
  width: 250px;
  right: 0;
  top: 0;
  background: #d9d9d9;
  border-left: 1px solid #ccc;
  height: calc(100vh);
  white-space: pre;
}

@keyframes wave {
  0%,
  60%,
  100% {
    transform: initial;
  }
  30% {
    transform: translateY(-8px);
  }
}
.yvebot-chat {
  display: flex;
  flex-direction: column;
}
/*@-moz-document url-prefix() { .selector { color: red; } }*/
</style>
